import gql from "graphql-tag";

export const MY_CAFETERIA_APPROVE_CURRENT_STATEMENT = gql`
  mutation approveCurrentCafeteriaStatement(
    $contractCode: String
    $currentItemStartDate: String
  ) {
    approveCurrentCafeteriaStatement(
      contractCode: $contractCode
      currentItemStartDate: $currentItemStartDate
    ) {
      result
      messages
    }
  }
`;

export default MY_CAFETERIA_APPROVE_CURRENT_STATEMENT;
